// extracted by mini-css-extract-plugin
export var fadeInOut = "_1s-3";
export var icon = "_1s-4";
export var savedIndicator = "_1s-2";
export var savingIndicator = "_1s-0";
export var spin = "_1s-1";